module.exports = __webpack_public_path__ + "static/media/Syndra.f3d9ed36.png";